import { FC, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CurrentUserReducer, RootReducer, StreamingReducer } from '../../../../../../models/Redux';
import { ViewerState } from '../../../../../../models/StreamingState';
import { SET_LOCAL_STREAMING_STATE } from '../../../../../../store/actions/Streaming.actions';
import ViewerDialogItem from '../ViewerDialogItem';
import { useStyles } from './styles';

interface ParticipantListDialogProps {
    mobileLayout?: boolean;
}

const ParticipantListDialog: FC<ParticipantListDialogProps> = ({ mobileLayout }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const {
        user: { user_ide: userIde },
    } = useSelector<RootReducer, CurrentUserReducer>(state => state.currentUser);
    const {
        eventData: {
            user: { user_ide: influencerUserIde },
        },
        streamingState: {
            // @ts-ignore
            current_state: { viewers, banned_viewers: bannedViewers, admin_users: adminUsers },
        },
        localStreamingState,
        localStreamingState: { showParticipantList },
    } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);

    const isEventInfluencer = useMemo(() => influencerUserIde === userIde, [influencerUserIde, userIde]);

    const dispatch = useDispatch();

    const onDismiss = () => {
        dispatch({
            type: SET_LOCAL_STREAMING_STATE,
            payload: {
                ...localStreamingState,
                showParticipantList: false,
            },
        });
    };

    return (
        <Dialog open={showParticipantList} onClose={onDismiss} maxWidth="lg" fullWidth>
            <DialogTitle>{t('Participants connected')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Grid
                        container
                        justify="flex-start"
                        alignContent="stretch"
                        alignItems="flex-start"
                        direction="row"
                        className={classes.viewerContainer}
                    >
                        {viewers.map((viewerWaiting: ViewerState, index: number) => {
                            return (
                                <ViewerDialogItem
                                    key={index}
                                    mobileLayout={mobileLayout}
                                    isEventInfluencer={isEventInfluencer}
                                    avatar={viewerWaiting.user_avatar}
                                    username={viewerWaiting.username}
                                    isBanned={
                                        !!bannedViewers.find(
                                            (username: string) => username === viewerWaiting.username,
                                        )
                                    }
                                    isAdmin={adminUsers?.find(
                                        (username: string) => username === viewerWaiting.username,
                                    )}
                                />
                            );
                        })}
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDismiss} autoFocus>
                    <Typography>{t('Close')}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ParticipantListDialog;
